/*
  Fișier: gdc-cart.js
  Locație în Shopify: assets/gdc-cart.js
  Includere în layout/theme.liquid (înainte de </body>):
    {{ 'gdc-cart.js' | asset_url | script_tag }}
*/

document.addEventListener('DOMContentLoaded', function () {

  document.querySelectorAll('.gdc-add-to-cart').forEach(function (button) {
    button.addEventListener('click', function () {
      var variantId = this.dataset.productId;
      if (!variantId) return;

      var btn = this;
      btn.classList.add('is-loading');
      btn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Network error');
          return response.json();
        })
        .then(function (data) {
          /* Opțional: actualizează counter-ul din navbar */
          updateCartCount();

          /* Feedback vizual scurt */
          btn.classList.remove('is-loading');
          btn.classList.add('btn-success');
          btn.querySelector('.btn-text').textContent = '✓ Adăugat!';

          setTimeout(function () {
            btn.classList.remove('btn-success');
            btn.querySelector('.btn-text').innerHTML =
              '<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" viewBox="0 0 16 16" aria-hidden="true" style="vertical-align:-2px;margin-right:4px;"><path d="M0 1.5A.5.5 0 0 1 .5 1H2a.5.5 0 0 1 .485.379L2.89 3H14.5a.5.5 0 0 1 .491.592l-1.5 8A.5.5 0 0 1 13 12H4a.5.5 0 0 1-.491-.408L2.01 3.607 1.61 2H.5a.5.5 0 0 1-.5-.5zM5 12a2 2 0 1 0 0 4 2 2 0 0 0 0-4zm7 0a2 2 0 1 0 0 4 2 2 0 0 0 0-4z"/></svg> Adaugă în coș';
            btn.disabled = false;
          }, 2000);
        })
        .catch(function (err) {
          console.error('Cart error:', err);
          btn.classList.remove('is-loading');
          btn.disabled = false;
        });
    });
  });

  /* Actualizează numărul de produse din coș în navbar */
  function updateCartCount() {
    fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var counters = document.querySelectorAll('[data-cart-count]');
        counters.forEach(function (el) {
          el.textContent = cart.item_count;
        });
      })
      .catch(function () {});
  }

});
